import { SimpleSwap1Inch } from './actions/SimpleSwap1Inch';
var actions = {
    SimpleSwap1Inch: SimpleSwap1Inch,
};
var Inch = {
    actions: actions,
};
export { Inch };
